


















import Vue, { PropType } from 'vue'
import { Dictionary, getText, getDefaultLanguage, getSupportedLanguages } from '../js/lang'

interface SupportedLanguage {
  label: string
  value: string
}

export default Vue.extend({
  name: 'lang-selector',
  props: {
    value: {
      type: String as PropType<string>,
      required: true
    }
  },
  data() {
    return {
      supports: getSupportedLanguages().map(key => ({
        label: Dictionary[key].label,
        value: key
      })) as SupportedLanguage[]
    }
  },
  computed: {
    label(): string {
      for (let support of this.supports) {
        if (support.value === this.value) {
          return support.label
        }
      }
      return this.supports[0].label
    }
  },
  mounted() {
    // Initialization if needed
  },
  methods: {
    l(key: string): string {
      return getText(this.value, key)
    }
  }
})
